module.exports = __webpack_public_path__ + "images/jw-trophy_only-50x50-67a53cae2f046aeaaf9c7cf777f8b1c6.png";